export default [
    {
      path: '/admin/corporate/branch-profiles',
      name: 'branch-profile',
      meta: { requiresAuth: true },
      component: () => import('@/pages/corporate/branch/index.vue')
    }
  ]
